import styled from 'styled-components';

const Container = styled.div`
    display: flex;

    .rt-el{
        padding:10px;
        border-radius:5px;

        font-size:14px;
        font-weight: 600;
        color:white;

        cursor: pointer;

        transition: all .3s;
    }
`;

export {
    Container
}